import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useSuppliers, Supplier } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<Supplier>
      useData={useSuppliers}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
